import { render, staticRenderFns } from "./adver.vue?vue&type=template&id=046a1e61&scoped=true"
import script from "./adver.vue?vue&type=script&lang=js"
export * from "./adver.vue?vue&type=script&lang=js"
import style0 from "./adver.vue?vue&type=style&index=0&id=046a1e61&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046a1e61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('046a1e61')) {
      api.createRecord('046a1e61', component.options)
    } else {
      api.reload('046a1e61', component.options)
    }
    module.hot.accept("./adver.vue?vue&type=template&id=046a1e61&scoped=true", function () {
      api.rerender('046a1e61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/adver.vue"
export default component.exports